import React from "react";

const KamfupiCost = () => {
  return (
    <div>
      <iframe
        src="/kamfupi-cost.html"
        title="Landing Page"
        width="100%"
        height="500px"
        style={{ width: "100%", height: "100vh", border: "none" }}
      />
    </div>
  );
};

export default KamfupiCost;
